export const tableRangeSettings = {
	drawer: {
		title: "Configure Environments",
		saveBtn: "Save",
	},
	header: {
		addBtn: "Add environment",
		searchPlaceholder: "Search by bar",
	},
	card: {
		title: "Environment {{from}} to {{to}}",
		subtitle: "Tables {{from}} to {{to}}",
		barsLabel: "Print on bars",
		deleteBtn: "Delete Environment",
		hideBtn: "Hide",
	},
	list: {
		emptyState: {
			title: "Nothing here yet",
			subtitle: "You haven't added any environments for your establishment.",
		},
	},
	form: {
		status: {
			errors: {
				description:
					"It was not possible to add the range. Check if there is not a table number already used on another range.",
				title: "Something went wrong.",
			},
			success: {
				titleEditing: "Updated successfully.",
				titleCreating: "Table ranges created successfully!",
			},
		},
		generalWrapperLabel: "Range {{number}}",
		intervalWrapperLabel: "Table range",
		bars: {
			label: "Bars that will print orders from this environment",
			placeholder: "Search by name",
			selectedBar: "bar selected",
			selectedBars_one: "{{count}} bar selected",
			selectedBars_other: "{{count}} bars selected",
		},
		environmentNameLabel: "Environment name",
		environmentNamePlaceholder: "Set a title for this table group",
		removeIntervalBtn: "Remove range",
		editingWarningTooltip: "You can't add new ranges in edit mode.",
		addIntervalBtn: "Add another environment",
		errors: {
			missingEnvironmentName: "Type the environment name (range {{number}})",
			atLeastOneBar:
				"You must select at least one bar to print the orders of the tables above. (range {{number}})",
			missingFromTable:
				"Type the number of the first table of the range (range {{number}})",
			missingToTable: "Type the number of the last table of the range (range {{number}})",
			fromTableAlreadyUsed:
				"The first table of the range (range {{number}}) is already used on another range.",
			toTableAlreadyUsed:
				"The last table of the range (range {{number}}) is already used on another range.",
		},
	},
	deleteModal: {
		title: "Do you want to delete this environment?",
		messageLine1:
			"Assigned tables will also be deleted, but their related data will remain in your reports.",
		messageLine2: "This action cannot be undone.",
		confirmBtn: "Yes, I want to delete",
	},
	tabs: {
		generalSettings: "General Settings",
		printByTableSettings: "Configure Table Printing",
	},
};
